import { render, staticRenderFns } from "./RewardInputState.vue?vue&type=template&id=1edac03d"
import script from "./RewardInputState.vue?vue&type=script&lang=js"
export * from "./RewardInputState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports